<template>
    <el-row :gutter="30"  class="mw-100 manage-seo" >
        
        <el-col :lg="24" :xs="24">
            
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentSEORef"
                    :model="currentSEOData"
                    :rules="currentSEODataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageSEO('addSEORef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentSEOData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addSEORef"
                            :model="currentSEOData"
                            :rules="currentSEODataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentSEOData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentSEOData.translates[index].description"></el-input>    
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    
    data(){
        return {
            isAddSEO:true,
            currentSEO:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentSEOData:{},
            currentSEODataRules:{
                translates:this.$setTranslateRules(['title','description']),
            }
        };
    },
    computed:{
        cachedSEO(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.seos.currentSEO || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedSEO.id) {
            this.isAddSEO = false;
            this.currentSEOData = JSON.parse(JSON.stringify(this.cachedSEO))
            this.currentSEOData.translates = this.$filterPublishedTranslates(this.currentSEOData.translates)
        }else{
            this.$router.push({
                name:'seo-list',
            })
            
        }
    },
    
    methods:{
        initState(){
            return {
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageSEO(formName){
            let successForm = [];
            this.$refs['addParentSEORef'].validate(async (parentValid) => {
                if (parentValid) {
                    for (let index = 0; index < this.$refs[formName].length; index++) {
                        const element = this.$refs[formName][index];
                        element.validate(async (valid) => {
                            if (!valid) {
                                this.$message({
                                    message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                                    type:'info',
                                    duration:5000,
                                    showClose: true,
                                });
                            }
                        }).then(data =>{
                            let indexOfIndex = successForm.indexOf(index);
                            if (data){
                                successForm.push(index);
                                if (successForm.length == this.$refs['addSEORef'].length){
                                    this.manageSEOAfterValidate()
                                }
                            }else{
                                if(indexOfIndex != -1) {
                                    successForm.splice(indexOfIndex,1);
                                }
                            }
                        })  
                    }
                }else{
                    return false
                }
            })
            
           
            
            
            
            
            
        },
        async manageSEOAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddSEO ? 'addSEO':'editSEO',this.currentSEOData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllSEOs');
                this.$router.push({
                    name:'seo-list'
                })
            }
        },
        
    }
}
</script>
<style lang="scss">
    .manage-seo {
        .ck-editor {
            width:100%;
        }
    }
</style>